(function () {
  function initialiseUploaders() {
    document
      .querySelectorAll('[data-sp-photo-uploader]')
      .forEach(function (root) {
        if (root.dataset.spPhotoReady === 'true') {
          return;
        }
        root.dataset.spPhotoReady = 'true';
        var inputs = Array.from(
          root.querySelectorAll('[data-sp-photo-input]')
        );
        var submitButton =
          root.querySelector('[data-sp-photo-submit]');
        var skipButton =
          root.querySelector('[data-sp-photo-skip]');
        var status =
          root.querySelector('[data-sp-photo-status]');
        var referenceInput =
          root.querySelector('[data-sp-photo-reference]');
        var uploading = false;
        var generation = 0;
        var uploadController = null;
        var files =
          new Array(inputs.length).fill(null);
        var previewUrls =
          new Array(inputs.length).fill(null);
        var requiredCount =
          parseInt(
            root.dataset.required || '1',
            10
          );
        /*
         * Server allows 32 MB POST requests.
         *
         * Keep the actual photo payload below that
         * so multipart/form-data overhead has room.
         */
        var maxFileSize =
          12 * 1024 * 1024;
        var maxTotalSize =
          28 * 1024 * 1024;
        var allowedTypes = [
          'image/jpeg',
          'image/png',
          'image/webp'
        ];
        function setStatus(message) {
          if (status) {
            status.textContent =
              message || '';
          }
        }
        function selectedCount() {
          return files
            .filter(Boolean)
            .length;
        }
        function selectedTotalSize() {
          return files.reduce(
            function (total, file) {
              return (
                total +
                (
                  file
                    ? file.size
                    : 0
                )
              );
            },
            0
          );
        }
        function updateButton() {
          if (!submitButton) {
            return;
          }
          var enoughPhotos =
            selectedCount() >= requiredCount;
          var withinSizeLimit =
            selectedTotalSize() <= maxTotalSize;
          submitButton.disabled =
            uploading || !enoughPhotos ||
            !withinSizeLimit;
        }
        function clearPreviewUrl(index) {
          if (!previewUrls[index]) {
            return;
          }
          URL.revokeObjectURL(
            previewUrls[index]
          );
          previewUrls[index] = null;
        }
        inputs.forEach(
          function (input, index) {
            var slot =
              input.closest(
                '[data-sp-photo-slot]'
              );
            if (!slot) {
              return;
            }
            var empty =
              slot.querySelector(
                '[data-sp-photo-empty]'
              );
            var preview =
              slot.querySelector(
                '[data-sp-photo-preview]'
              );
            var replace =
              slot.querySelector(
                '[data-sp-photo-replace]'
              );
              var cameraTrigger =
  slot.querySelector(
    '[data-sp-photo-camera]'
  );
if (cameraTrigger) {
  cameraTrigger.addEventListener(
    'click',
    function (event) {
      /*
       * This element sits inside the tile's
       * label. Stop the label from also opening
       * the normal photo-library picker.
       */
      event.preventDefault();
      event.stopPropagation();
      /*
       * Ask supported mobile browsers to open
       * the rear-facing camera.
       */
      input.setAttribute(
        'capture',
        'environment'
      );
      input.click();
      /*
       * Remove capture immediately afterwards
       * so the normal UPLOAD route continues
       * to offer the photo library/files.
       */
      window.setTimeout(
        function () {
          input.removeAttribute(
            'capture'
          );
        },
        0
      );
    }
  );
}
            input.addEventListener(
              'change',
              function () {
                var file =
                  input.files &&
                  input.files[0]
                    ? input.files[0]
                    : null;
                if (!file) {
                  return;
                }
                /*
                 * File type
                 */
                if (
                  allowedTypes.indexOf(
                    file.type
                  ) === -1
                ) {
                  input.value = '';
                  setStatus(
                    'Please use a JPEG, PNG or WebP photograph.'
                  );
                  return;
                }
                /*
                 * Individual file size
                 */
                if (
                  file.size > maxFileSize
                ) {
                  input.value = '';
                  setStatus(
                    'Each photograph must be 12 MB or smaller.'
                  );
                  return;
                }
                /*
                 * Combined request size.
                 *
                 * Exclude any existing photo in
                 * this same slot because it is
                 * being replaced.
                 */
                var totalWithoutCurrent =
                  files.reduce(
                    function (
                      total,
                      existingFile,
                      existingIndex
                    ) {
                      if (
                        existingIndex === index
                      ) {
                        return total;
                      }
                      return (
                        total +
                        (
                          existingFile
                            ? existingFile.size
                            : 0
                        )
                      );
                    },
                    0
                  );
                if (
                  totalWithoutCurrent +
                  file.size >
                  maxTotalSize
                ) {
                  input.value = '';
                  setStatus(
                    'The combined photographs are too large. Please use smaller images.'
                  );
                  updateButton();
                  return;
                }
                /*
                 * Store the selected photograph.
                 */
                clearPreviewUrl(index);
                files[index] =
                  file;
                previewUrls[index] =
                  URL.createObjectURL(
                    file
                  );
                if (preview) {
                  preview.src =
                    previewUrls[index];
                  preview.hidden =
                    false;
                }
                if (empty) {
                  empty.hidden =
                    true;
                }
                if (replace) {
                  replace.hidden =
                    false;
                }
                setStatus('');
                updateButton();
              }
            );
          }
        );
        async function uploadPhotos() {
          if (!submitButton || uploading) {
            return;
          }
          /*
           * If this uploader has already
           * completed successfully, simply
           * return the existing reference.
           */
          if (root.dataset.reference) {
            root.dispatchEvent(
              new CustomEvent(
                'sp:photo-upload-complete',
                {
                  bubbles: true,
                  detail: {
                    reference:
                      root.dataset.reference,
                    photoCount:
                      selectedCount(),
                    context:
                      root.dataset.context || '',
                    mode:
                      root.dataset.mode || ''
                  }
                }
              )
            );
            return;
          }
          if (
            selectedCount() <
            requiredCount
          ) {
            setStatus(
              requiredCount === 1
                ? 'Please add at least one photograph.'
                : 'Please add all four photographs.'
            );
            return;
          }
          if (
            selectedTotalSize() >
            maxTotalSize
          ) {
            setStatus(
              'The combined photographs are too large. Please use smaller images.'
            );
            return;
          }
          var endpoint =
            root.dataset.endpoint;
          if (!endpoint) {
            setStatus(
              'Photo upload is temporarily unavailable.'
            );
            return;
          }
          var formData =
            new FormData();
          files.forEach(
            function (file, index) {
              if (!file) {
                return;
              }
              formData.append(
                'photos[]',
                file,
                file.name
              );
              formData.append(
                'photo_labels[]',
                inputs[index]
                  .dataset
                  .photoLabel || ''
              );
            }
          );
          formData.append(
            'context',
            root.dataset.context || ''
          );
          formData.append(
            'mode',
            root.dataset.mode || ''
          );

// Save diagnostic photographs without notifying the workshop.
// Notification happens after the completed assessment is submitted.
if ((root.dataset.context || '') === 'diagnostics') {
  formData.set('defer_notification', '1');
}


/* Capture separate first and last names for Workshop Review. */
if (
  (root.dataset.context || '') === 'diagnostics' &&
  root.closest('#SPWorkshopReviewPhotos')
) {
  var firstNameField = document.getElementById(
    'SPWorkshopReviewFirstName'
  );
  var lastNameField = document.getElementById(
    'SPWorkshopReviewLastName'
  );
  var combinedNameField = document.getElementById(
    'SPWorkshopReviewName'
  );

  if (firstNameField && lastNameField) {
    var firstName = firstNameField.value.trim();
    var lastName = lastNameField.value.trim();

    if (!firstName || !lastName) {
      setStatus('Please enter both your first and last name.');
      (firstName ? lastNameField : firstNameField).focus();
      return;
    }

    var fullName = firstName + ' ' + lastName;

    if (combinedNameField) {
      combinedNameField.value = fullName;
    }

    formData.set('first_name', firstName);
    formData.set('last_name', lastName);
    formData.set('name', fullName);
  }
}


          
          /*
           * The surrounding Diagnostics /
           * Contact system can attach its own
           * information here.
           */
          var beforeUploadEvent =
  new CustomEvent(
    'sp:photo-upload-before',
    {
      bubbles: true,
      cancelable: true,
      detail: {
        formData: formData
      }
    }
  );
var canContinue =
  root.dispatchEvent(
    beforeUploadEvent
  );
if (!canContinue) {
  updateButton();
  return;
}
          var uploadGeneration = generation;
          uploadController = new AbortController();
          uploading = true;
          inputs.forEach(function(input) { input.disabled = true; });
          if (skipButton) skipButton.disabled = true;
          root.classList.add(
            'is-uploading'
          );
          submitButton.disabled =
            true;
          setStatus(
            'Adding photographs…'
          );
          try {
            var response =
              await fetch(
                endpoint,
                {
                  method: 'POST',
                  body: formData,
                  signal: uploadController.signal
                }
              );
            if (uploadGeneration !== generation) return;
            var result;
            try {
              result =
                await response.json();
            } catch (parseError) {
              throw new Error(
                'The upload server returned an unexpected response. Please try again.'
              );
            }
            if (uploadGeneration !== generation) return;
            if (
              !response.ok ||
              !result.success ||
              !result.reference
            ) {
              throw new Error(
                result.error ||
                'Unable to upload photographs.'
              );
            }
            /*
             * Store returned reference locally.
             */
            root.dataset.reference =
              result.reference;
            if (referenceInput) {
              referenceInput.value =
                result.reference;
            }
            setStatus(
              'Photographs added.'
            );
            /*
             * Hand control back to whatever
             * invoked the reusable uploader.
             */
            root.dispatchEvent(
              new CustomEvent(
                'sp:photo-upload-complete',
                {
                  bubbles: true,
                  detail: {
                    reference:
                      result.reference,
                    photoCount:
                      result.photo_count ||
                      selectedCount(),
                    expiresAt:
                      result.expires_at || '',
                    context:
                      root.dataset.context || '',
                    mode:
                      root.dataset.mode || ''
                  }
                }
              )
            );
          } catch (error) {
            if (uploadGeneration !== generation) return;
            setStatus(
              error &&
              error.message
                ? error.message
                : 'Unable to upload photographs.'
            );
            updateButton();
          } finally {
            if (uploadGeneration !== generation) return;
            uploading = false;
            inputs.forEach(function(input) { input.disabled = false; });
            if (skipButton) skipButton.disabled = false;
            if (!root.dataset.reference) updateButton();
            root.classList.remove(
              'is-uploading'
            );
          }
        }
        /*
         * Upload photographs
         */
        if (submitButton) {
          submitButton.addEventListener(
            'click',
            uploadPhotos
          );
        }
        /*
         * Optional-photo route
         */
        if (skipButton) {
          skipButton.addEventListener(
            'click',
            function () {
              root.dispatchEvent(
                new CustomEvent(
                  'sp:photo-upload-skip',
                  {
                    bubbles: true,
                    detail: {
                      context:
                        root.dataset.context || '',
                      mode:
                        root.dataset.mode || ''
                    }
                  }
                )
              );
            }
          );
        }
/* -----------------------------------------------
   RESET REUSABLE UPLOADER
   Used when the same uploader component is
   opened for another pair in the same order.
\----------------------------------------------- */
root.addEventListener(
  'sp:photo-uploader-reset',
  function() {
    generation++;
    if (uploadController) uploadController.abort();
    uploading = false;
    inputs.forEach(function(input) { input.disabled = false; });
    if (skipButton) skipButton.disabled = false;
    delete root.dataset.reference;
    if (referenceInput) {
      referenceInput.value = '';
    }
    inputs.forEach(
      function(input, index) {
        clearPreviewUrl(index);
        files[index] = null;
        input.value = '';
        var slot =
          input.closest(
            '[data-sp-photo-slot]'
          );
        if (!slot) {
          return;
        }
        var empty =
          slot.querySelector(
            '[data-sp-photo-empty]'
          );
        var preview =
          slot.querySelector(
            '[data-sp-photo-preview]'
          );
        var replace =
          slot.querySelector(
            '[data-sp-photo-replace]'
          );
        if (preview) {
          preview.hidden = true;
          preview.removeAttribute('src');
        }
        if (empty) {
          empty.hidden = false;
        }
        if (replace) {
          replace.hidden = true;
        }
      }
    );
    setStatus('');
    root.classList.remove(
      'is-uploading'
    );
    updateButton();
  }
);
        updateButton();
      });
  }
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseUploaders
    );
  } else {
    initialiseUploaders();
  }
  /*
   * Reinitialise if Shopify reloads
   * a section inside the theme editor.
   */
  document.addEventListener(
    'shopify:section:load',
    initialiseUploaders
  );
})();
